var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-tabs",
        {
          staticClass: "mb-0 bg-white",
          attrs: { type: "card" },
          on: { "tab-click": _vm.typeClick },
          model: {
            value: _vm.listQuery.article_type,
            callback: function ($$v) {
              _vm.$set(_vm.listQuery, "article_type", $$v)
            },
            expression: "listQuery.article_type",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "最新公告", name: "1" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "头条新闻", name: "2" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "学习教程", name: "3" } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "p-10 bg-white" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                id: "order_table",
                data: _vm.list,
                "element-loading-text": "Loading",
                stripe: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "封面图" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-image", {
                          staticStyle: { width: "60px", height: "60px" },
                          attrs: { src: scope.row.img_url, fit: "cover" },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "标题" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "el-link" }, [
                          _vm._v(_vm._s(scope.row.title)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.parseTime(
                                scope.row.add_date,
                                "{y}-{m}-{d} {h}:{i}"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              round: "",
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.getDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "p-20 flex justify-center" },
            [
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listQuery.page_num > 0,
                    expression: "listQuery.page_num > 0",
                  },
                ],
                attrs: {
                  page: _vm.listQuery.start,
                  limit: _vm.listQuery.limit,
                  "page-count": _vm.listQuery.page_num,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.listQuery, "start", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.listQuery, "limit", $event)
                  },
                  pagination: _vm.getList,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: _vm.info.title, visible: _vm.detailVisible },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _c("div", {
            staticClass: "max-w bg-gray",
            domProps: { innerHTML: _vm._s(_vm.info.content) },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }